export const DELIVERY_PRODUCTS: { [key: string]: string } = {
  "test-fokus": "sid:JleF1H8L-dZwNw744Pc2M",
  fokus: "sid:58RAor9IXy_ntdljLH38l",
  elbilen: "sid:5NmkiLCJhbGciOiJSUz",
  popark: "issn:0281-014X",
  "modern-psykologi": "issn:2000-4087",
  kondis: "issn:0802-0698",
};
